import PropTypes from "prop-types";

import FnrIcon from "UI/FnrIcon/FnrIcon";

import FnrLabeledIconContainer from "./FnrLabeledIconContainer";

const fnrLabeledIconVariants = {
  greyHeader: "greyHeader",
  leftColumn: "leftColumn",
  greyHeaderColumn: "greyHeaderColumn",
  disabled: "disabled",
  small: "small",
  default: "default",
};

/**
 *
 * @param {Object} param0
 * @param {"greyHeader"|"leftColumn"|"greyHeaderColumn"|"small"|"disabled"|"default"} param0.variant
 * @param {object} param0.icon
 */
const FnrLabeledIcon = ({ variant = "default", icon, children, ...rest }) => {
  return (
    <FnrLabeledIconContainer $variant={variant} {...rest}>
      {/* This div receives styles from the container */}
      <div data-cy={`LabeledIcon_${variant}_Icon`}>
        <FnrIcon icon={icon} />
      </div>
      <span>{children}</span>
    </FnrLabeledIconContainer>
  );
};

FnrLabeledIcon.propTypes = {
  icon: PropTypes.string.isRequired,
  variant: PropTypes.oneOf(Object.keys(fnrLabeledIconVariants)),
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
};

export { fnrLabeledIconVariants };
export default FnrLabeledIcon;
